import { configureStore } from '@reduxjs/toolkit'
import { logger } from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist'; // Import persistStore
import persistConfig from './persistConfig'; // Import the persistConfig
import { combineReducers } from 'redux'; 
import { onboardingReducer } from './reducers/onboarding'; // Import the onboarding reducer
import { appApi } from '../services/app_api';
import { adminApi } from '../services/admin_endpoints';
// Side-effect imports: each file injects its endpoints into the shared appApi.
import '../services/event_dashboard/event_endpoints';
import '../services/event_dashboard/players_endpoints';
import '../services/event_dashboard/event_logs_endpoints';
import '../services/event_dashboard/tables_endpoints';
import '../services/event_dashboard/rounds_endpoints';
import '../services/event_dashboard/groups_endpoints';
import '../services/event_dashboard/matches_endpoints';
import '../services/event_dashboard/instances_endpoints';
import '../services/event_dashboard/event_results_endpoints';
import '../services/events_endpoints';
import '../services/users_endpoints';
import '../services/customer_endpoints';
import '../services/customer_events_endpoints';
import '../services/customer_managers_endpoints';
import '../services/customer_point_categories_endpoints';

const rootReducer = combineReducers({
  onboarding: onboardingReducer,
  [appApi.reducerPath]: appApi.reducer,
  [adminApi.reducerPath]: adminApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
const isDevelopment = process.env.NODE_ENV !== 'production';

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    const middleware =
      getDefaultMiddleware()
        .concat(appApi.middleware)
        .concat(adminApi.middleware);
    if (isDevelopment) {
      middleware.push(logger);
    }
    return middleware;
  },
  devTools: isDevelopment,
});

const persistor = persistStore(store);

export { store, persistor }